import React, { useContext, useState } from "react";
import { LOG_IN } from "../../api";
import { AccountContext } from "../../context/accountContext";
import {
  BoldLink,
  BoxContainer,
  FormContainer,
  Input,
  MutedLink,
  SubmitButton,
} from "../../styles/communityCommon";
import { Marginer } from "../Marginer";

export function LoginForm(props) {
  const { switchToSignup } = useContext(AccountContext);

  const [userName, setUserName] = useState("");
  const [userPassword, setUserPassword] = useState("");

  const loginHanlder = () => {
    // Login API CALL
    LOG_IN(userName, userPassword)
      .then((res) => {
        console.log("Login res: ", res);
        props.onChange(res.data);
      })
      .catch((er) => {
        console.log("Login Error: ", er);
      });
  };

  return (
    <BoxContainer>
      <FormContainer>
        <Input
          type="text"
          placeholder="Username"
          onChange={(e) => {
            setUserName(e.target.value);
          }}
        />
        <Input
          type="password"
          placeholder="Password"
          onChange={(e) => {
            setUserPassword(e.target.value);
          }}
        />
      </FormContainer>
      <Marginer direction="vertical" margin={10} />
      <MutedLink href="#">Forget your password?</MutedLink>
      <Marginer direction="vertical" margin="1.6em" />
      <SubmitButton type="submit" onClick={loginHanlder}>
        Signin
      </SubmitButton>
      <Marginer direction="vertical" margin="1em" />
      <MutedLink href="#">
        Don't have an accoun?{" "}
        <BoldLink href="#" onClick={switchToSignup}>
          Signup
        </BoldLink>
      </MutedLink>
    </BoxContainer>
  );
}
